import { useModals } from "src/components/Modals";
import { Button, Color, Flex, Icon, Modal, Text } from "src/elements";

import { ConfirmModalProps } from "./store/types";
import { useAtom } from "jotai";
import { confirmModalDataAtom } from "./store/atoms";
import { useEffect, useState } from "react";

export const ModalConfirm = () => {
  const [data, setData] = useAtom(confirmModalDataAtom);

  useEffect(() => {
    return () => {
      setData(null);
    };
  }, []);

  if (!data) {
    return null;
  }

  return <ModalConfirmInner {...data} />;
};

const ModalConfirmInner = ({
  title,
  description,
  width = "400px",
  icon,
  buttons,
}: ConfirmModalProps) => {
  const { closeModal: _closeModal } = useModals();
  const [pendingButtonId, setPendingButtonId] = useState<string | null>(null);

  const closeModal = () => {
    _closeModal("ModalConfirm");
  };

  return (
    <Modal name="ModalConfirm" width={width} isConfirmModal>
      <Flex column padding="20px 10px 10px 10px" gap="30px" justify="center">
        <Flex column gap="10px" justify="center">
          {icon && <Icon name={icon.name} color={icon.color} size={40} />}

          <Text variant="h5" textAlign="center">
            {title}
          </Text>

          {description && typeof description === "string" && (
            <Text textAlign="center" variant="small2" color={Color.textSecondary}>
              {description}
            </Text>
          )}

          {description && typeof description === "object" && description}
        </Flex>

        <Flex width="100%" justify="space-between" gap="10px">
          {buttons.map((button) => (
            <Button
              key={button.id}
              name={button.id}
              width="100%"
              color={button.color}
              variant={button.variant}
              isDisabled={pendingButtonId !== null}
              isLoading={pendingButtonId === button.id}
              onClick={async () => {
                if (pendingButtonId !== null) {
                  return;
                }

                setPendingButtonId(button.id);
                try {
                  const shouldClose = (await button.onClick?.()) !== false;
                  if (shouldClose) {
                    closeModal();
                  }
                } finally {
                  setPendingButtonId(null);
                }
              }}
            >
              {button.label}
            </Button>
          ))}
        </Flex>
      </Flex>
    </Modal>
  );
};
